import script from "./TheOfficialMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./TheOfficialMaterial.vue?vue&type=script&setup=true&lang=js"

import "./TheOfficialMaterial.vue?vue&type=style&index=0&id=2e694ac4&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e694ac4"]])

export default __exports__